<template>
    <div class="delivery-sec__body">
        <div class="delivery-sec__content-wrapper">
            <h1 class="delivery-sec__title">
                {{ trans('del1') }}.
            </h1>
            <div class="delivery-sec__content-element redactor-container">
                <h2 class="title-element">
                    {{ trans('del2') }}
                </h2>
                <div class="imgV1">
                    <img class="img-element" src="https://batnorton.com/img/del1.png" alt="">
                </div>
                <p class="text-element">
                    <b class="strong-element">
                        {{ trans('del3') }}:
                    </b>
                </p>
                <ul class="list list">
                    <li class="list__element list__element">
                        {{ trans('del4') }}
                    </li>
                    <li class="list__element list__element">
                        {{ trans('del5') }}
                    </li>
                </ul>
            </div>

            <div class="delivery-sec__content-element redactor-container">
                <h2 class="title-element">
                    {{ trans('del6') }}
                </h2>
                <div class="imgV1">
                    <img class="img-element" src="https://batnorton.com/img/del2.png" alt="">
                </div>
                <p class="text-element">
                    <b class="strong-element">
                        {{ trans('del7') }}.
                    </b>
                </p>
                <ul class="list list">
                    <li class="list__element list__element">
                        {{ trans('del8') }}.
                    </li>
                </ul>
            </div>
            <div class="delivery-sec__content-element redactor-container">
                <h2 class="title-element">
                    {{ trans('del9') }}:
                </h2>
                <ul class="list list">
                    <li class="list__element list__element">
                        {{ trans('del10') }}
                    </li>
                </ul>
                <p class="text-element">
                    {{ trans('del11') }}.
                </p>

                <p class="text-element">
                    {{ trans('del12') }}.
                </p>

                <p class="text-element">
                    {{ trans('del13') }}
                    <a class="link-element" href="https://batnorton.com/contacts">
                        {{ trans('del14') }}
                    </a>.
                </p>
                <p class="text-element">
                    {{ trans('del15') }}.
                </p>
                <p class="text-element">
                    <b class="strong-element">
                        {{ trans('del16') }}.
                    </b>
                </p>
                <p class="text-element">
                <span class="text-element__grey">
                  {{ trans('del17') }}.
                </span>
                </p>
                <p class="text-element">
                <span class="text-element__grey">
                  {{ trans('del18') }}
                  <a class="link-element" href="mailto:info@batnorton.com">info@batnorton.com</a>
                  {{ trans('del19') }}
                  <a class="link-element" href="tel:+7 (499) 703-40-20">+7 (499) 703-40-20</a>
                </span>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>

</style>
